module.exports = __webpack_public_path__ + "static/media/banner_CoinToss-half.634dacc9.png";